import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const GroupWorkIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"group_work"} ref={ref}/>
});

GroupWorkIcon.displayName = "GroupWorkIcon";
